var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger1814 = function SvgHamburger1814(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A0A",
    fillRule: "evenodd",
    d: "M18 13a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2h16a1 1 0 0 1 1 1M18 7a1 1 0 0 1-1 1H1a1 1 0 0 1 0-2h16a1 1 0 0 1 1 1M18 1a1 1 0 0 1-1 1H1a1 1 0 0 1 0-2h16a1 1 0 0 1 1 1",
    clipRule: "evenodd"
  })));
};
export default SvgHamburger1814;